<div class="overflow-hidden rounded flex items-center justify-center border border-white h-6 w-6">
    <img
        class="h-full w-full object-cover"
        (error)="onProfileImageFailedToLoad()"
        src="{{ groupAvatar }}" />
</div>
